module.exports = __webpack_public_path__ + "img/07_shimizu_09.040c4309.jpg";